<script>
/**
 * ****************************************************************************
 * @description     :   List Component
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   Frontier Consulting
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import { mapActions } from 'vuex';
import messages, { MSG_TYPE, MSG_TITLE } from '@/utils/messages';

/**
 * Import template
 */
import template from './template.html';

/**
 * Define content of list component
 */
var ListSearch = {
    template: template,
    props: {
        label: String,
        listName: String,
        itemClass: String,
        labelClass: String,
        inputClass: String,
        data: Array,
        onClick: Function,
        onEdit: Function,
        onDelete: Function,
        onSelectRow: Function
    },
    watch: {},
    computed: {},
    methods: {
        ...mapActions('app', [
            'showHeaderError',
            'hideHeaderError',
            'showModalMessage'
        ]),
        doShowModalMessage() {
            this.showModal = true;
        },
        checkEdit(i) {
            this.data[i].isEdit = !this.data[i].isEdit;
        },
        saveEdit(i) {
            if (this.data[i].shitaukenameEdit == '') {
                this.showHeaderError(['下請会社名を入力してください']);
            } else {
                this.hideHeaderError([]);
                // this.data[i].isEdit = !this.data[i].isEdit;
                if (this.onEdit) {
                    this.onEdit(this.data[i], i);
                }
            }
        },
        removeRow(i) {
            const vm = this;
            vm.showModalMessage({
                type: MSG_TYPE.CONFIRM,
                title: MSG_TITLE.C003,
                content: messages.C035,
                callback: (ok) => {
                    if (ok) {
                        if (this.onDelete) {
                            this.onDelete(this.data[i], i);
                        }
                    }
                }
            });
        },
        selectRow(item) {
            if (this.onSelectRow) {
                this.onSelectRow(item);
            }
        }
    }
};
export default ListSearch;
</script>
